"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.7291 38.625C19.3696 38.6148 19.0243 38.4826 18.7499 38.25L8.58327 29.6458C8.42151 29.5198 8.28651 29.3629 8.18617 29.1841C8.08582 29.0053 8.02214 28.8083 7.99886 28.6046C7.97558 28.4009 7.99317 28.1946 8.05059 27.9978C8.10801 27.8009 8.20411 27.6176 8.33327 27.4583C8.59335 27.1709 8.95218 26.992 9.33827 26.9572C9.72436 26.9225 10.1094 27.0344 10.4166 27.2708L19.3541 34.8542L39.0208 11.9375C39.2887 11.5866 39.6851 11.3566 40.1227 11.298C40.5603 11.2394 41.0032 11.357 41.3541 11.625C41.705 11.893 41.935 12.2894 41.9936 12.7269C42.0522 13.1645 41.9346 13.6075 41.6666 13.9583L20.8333 38.0625C20.6981 38.2275 20.5302 38.3627 20.3402 38.4596C20.1501 38.5564 19.9421 38.6127 19.7291 38.625Z",
    fill: fill
  }));
};

exports["default"] = _default;